import { render, staticRenderFns } from "./BetInAcceptance.vue?vue&type=template&id=9bdb6808"
import script from "./BetInAcceptance.vue?vue&type=script&lang=js"
export * from "./BetInAcceptance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports